export default function getLabelWithRequired(label: string, isRequired: boolean, suffix: string = '') {
	return `${label}${isRequired ? '*' : ''}${suffix ? ` ${suffix}` : ''}`;
}
